import React, { useEffect, useState } from "react";
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Typography,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { Edit, Delete, Add } from "@mui/icons-material";
import CreateAnalyst from './market/createAnalyst'
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import endpoints from "../../endpoint";
import EditAnalyst from "./market/EditAnalyst";

const TeacherMarketPage = () => {
    const [open, setOpen] = useState(false);
    const [selectedWebinar, setSelectedWebinar] = useState(null);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [analyst, setAnalyst] = useState();



    const fetchAnalyst = async () => {
        try {

            const response = await axios.get(endpoints.serverBaseUrl + "api/market", {
                withCredentials: true,
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`
                }
            })
            setAnalyst(response.data.data)
        } catch (error) {
            toast.error("Internal Server Error")

        }
    }


    useEffect(() => {

        fetchAnalyst();
    }, [])


    const navigate = useNavigate();
    const handleEdit = (strategy) => {
        setSelectedWebinar(strategy);
        setEditOpen(true);
    };

    const handleDeleteClick = (strategy) => {
        setSelectedWebinar(strategy);
        setDeleteOpen(true);
    };
    const confirmDelete = async (id) => {
        try {
            const response = await axios.delete(
                endpoints.serverBaseUrl + "api/market/" + selectedWebinar._id,
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")} `,
                    },
                    withCredentials: true,
                }
            );
            if (response.data.success) {
                toast.success(response.data.success);
                fetchAnalyst()

            }
            if (response.data.error) {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Server error");
        }

        setDeleteOpen(false);
    };

    return (
        <Box sx={{ p: 3 }}>
            {/* Header Section */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                }}
            >
                <Typography variant="h5" sx={{textTransform:"capitalize"}} fontWeight="bold">
                    Publish Analyst
                </Typography>
                <Button
                    variant="contained"
                    sx={{textTransform:"capitalize"}}
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => {
                        setSelectedWebinar(null);
                        setOpen(true);
                    }}
                >
                    Publish Analyst
                </Button>
            </Box>

            <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {analyst?.map((strategy) => (
                            <TableRow
                                key={strategy?._id}
                                hover
                                sx={{ cursor: "pointer" }}
                                onClick={() => navigate(`/dashboard/analyst/${strategy?._id}`)}
                            >
                                <TableCell sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: 200, // Adjust based on your layout
                                }}> {strategy?.title?.split("\n")[0]}</TableCell>

                                
                                <TableCell
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: 200, // Adjust based on your layout
                                    }}
                                >
                                    {strategy?.description?.split("\n")[1]} {/* Show only the first line */}
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleEdit(strategy);
                                        }}
                                    >
                                        <Edit />
                                    </IconButton>
                                    <IconButton
                                        color="error"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteClick(strategy);
                                        }}
                                    >
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            {/* Delete Confirmation Modal */}
            <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete this strategy?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modals for Creating & Editing Strategies */}
            <CreateAnalyst open={open} onClose={() => {
                fetchAnalyst();
                setOpen(false)
            }} />
            <EditAnalyst
                open={editOpen}
                onClose={() => {
                    setEditOpen(false);
                    setSelectedWebinar(null);
                    fetchAnalyst();
                }}
                strategy={selectedWebinar}
            />
        </Box>
    )
}

export default TeacherMarketPage
